import React from "react";
import AiPower from "../../assets/images/AiPower.svg";
import Education from "../../assets/images/Education.svg";
import Mentor from "../../assets/images/Mentor.svg";
import Enterprise from "../../assets/images/Enterprise.svg";
import AiPowerIcon from "../../assets/icon/AiPower";
import EducationIcon from "../../assets/icon/Education";
import MentorIcon from "../../assets/icon/UserIcon";
import EnterpriseIcon from "../../assets/icon/Enterprise";
import FetureIcon from "../../assets/icon/FetureIcon";

const useCases = [
  {
    img: AiPower,
    icons: <AiPowerIcon />,
    title: "Warehouse Operations",
    content:
      "Implement AI-powered standard operating procedures to improve warehouse efficiency and reduce errors.",
    subTitle: "Streamlined SOP Management",
    subContent: "Features",
    subContentOne: "AI-powered SOP generation and updates",
    subContentTwo: "Real-time process optimization",
    subContentThree: "Automated compliance tracking",
    subContentFour: "Performance analytics dashboard",
  },
  {
    img: Education,
    icons: <EducationIcon />,
    title: "Education",
    content:
      "Personalized learning paths and intelligent test preparation assistance for students.",
    subTitle: "Enhanced Learning Experience",
    subContent: "Features",
    subContentOne: "Personalized study paths",
    subContentTwo: "Interactive learning modules",
    subContentThree: "Progress tracking analytics",
    subContentFour: "AI-driven assessments",
  },
  {
    img: Mentor,
    icons: <MentorIcon />,
    title: "Mentorship",
    content:
      "24/7 access to AI-powered mentorship and professional development support.",
    subTitle: "Expert Guidance",
    subContent: "Features",
    subContentOne: "Intelligent skill assessment",
    subContentTwo: "Personalized mentorship paths",
    subContentThree: "Real-time feedback system",
    subContentFour: "Career progression tracking",
  },
  {
    img: Enterprise,
    icons: <EnterpriseIcon />,
    title: "AI Integration",
    content:
      "Comprehensive AI integration for businesses seeking to optimize operations and decision-making processes.",
    subTitle: "Smart Enterprise Solutions",
    subContent: "Features",
    subContentOne: "Enterprise-wide AI deployment",
    subContentTwo: "Customized solution development",
    subContentThree: "Integration with existing systems",
    subContentFour: "Scalable AI infrastructure",
  },
];

const UseCases = () => {
  return (
    <div className="pb-12 lg:pb-100">
      <div className="container">
        <div className="text-center pb-6 lg:py-60">
          <h3
            className="title pb-5 tab:pb-30 border-b border-border_sec wow animate__animated animate__fadeIn"
            data-wow-delay="0.3s"
          >
            Use Cases
          </h3>
        </div>
        <div className="grid lg:grid-cols-2 gap-30">
          {useCases.map((item, index) => (
            <div
              key={index}
              className="border border-border_sec rounded-10 overflow-hidden p-4 tab:p-6 wow animate__animated animate__fadeInUp"
            >
              <h4 className="font-semibold mb-4 tab:mb-6">{item.title}</h4>
              <div className="relative max-h-[220px] overflow-hidden rounded-10">
                <img
                  src={item.img}
                  alt=""
                  className="max-h-[220px] h-full w-full object-cover bg-cover bg-center"
                />
                <div className="relative shadhow-blurs"></div>
                <div className="absolute left-5 bottom-5 z-20">
                  {item.icons}
                </div>
              </div>
              <div className="py-4 tab:py-6 grid gap-3">
                <h6 className="font-semibold text-black">{item.title}</h6>
                <p className="text-gray">{item.content}</p>
              </div>
              <div className="grid gap-3">
                <p className="flex items-center gap-3 font-medium">
                  <FetureIcon />
                  {item.subContent}
                </p>
                <ul
                  className="grid gap-2 ps-14 list-disc
"
                >
                  <li className="text-gray font-normal">
                    {item.subContentOne}
                  </li>
                  <li className="text-gray font-normal">
                    {item.subContentTwo}
                  </li>
                  <li className="text-gray font-normal">
                    {item.subContentThree}
                  </li>
                  <li className="text-gray font-normal">
                    {item.subContentFour}
                  </li>
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UseCases;
